var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-diff-view"},_vm._l((_vm.segments),function(seg,idx){return _c('span',{key:idx,class:_vm.segmentClass(seg.type)},[_vm._v(_vm._s(seg.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }